const mode = process.env.CONFIG_ENV || 'development';
const config = {
    production: {
        baseV1Url: 'https://www.textcafe.com',
        get apiUrl() {
            return `${config[mode].baseV1Url}/v2api`;
        },
        get logoutUrl() {
            return `${config[mode].baseV1Url}/logout`;
        },
        get loginUrl() {
            return `${config[mode].baseV1Url}/login`;
        },
        get templatesUrl() {
            return `${config[mode].baseV1Url}/templates`;
        },
        get subscribeUrl() {
            return `${config[mode].baseV1Url}/subscribe`;
        },
        get unSubscribeUrl() {
            return `${config[mode].baseV1Url}/unsubscribe`;
        },
        get widgetUrl() {
            return 'https://textcafe.co/widget/textcafe.widget.js';
        },
        get s3UploadBucketUrl() {
            return 'https://s3.amazonaws.com/textcafe.epubs';
        },
    },
    development: {
        baseV1Url: window.location.origin,
        get apiUrl() {
            return `${config[mode].baseV1Url}/v2api`;
        },
        get logoutUrl() {
            return `${config[mode].baseV1Url}/logout`;
        },
        get loginUrl() {
            return `${config[mode].baseV1Url}/login`;
        },
        get templatesUrl() {
            return `${config[mode].baseV1Url}/templates`;
        },
        get subscribeUrl() {
            return `${config[mode].baseV1Url}/subscribe`;
        },
        get unSubscribeUrl() {
            return `${config[mode].baseV1Url}/unsubscribe`;
        },
        get widgetUrl() {
            return 'http://localhost:8081/textcafe.widget.js';
        },
        get s3UploadBucketUrl() {
            return 'https://s3.amazonaws.com/textcafe.epubs';
        },
    },
    staging: {
        baseV1Url: 'https://staging.textcafe.com',
        get apiUrl() {
            return `${config[mode].baseV1Url}/v2api`;
        },
        get logoutUrl() {
            return `${config[mode].baseV1Url}/logout`;
        },
        get loginUrl() {
            return `${config[mode].baseV1Url}/login`;
        },
        get templatesUrl() {
            return `${config[mode].baseV1Url}/templates`;
        },
        get subscribeUrl() {
            return `${config[mode].baseV1Url}/subscribe`;
        },
        get unSubscribeUrl() {
            return `${config[mode].baseV1Url}/unsubscribe`;
        },
        get widgetUrl() {
            return 'https://textcafe.co/widget/textcafe.widget.js';
        },
        get s3UploadBucketUrl() {
            return 'https://s3.amazonaws.com/textcafe.epubs';
        },
    },
};

export default config[mode];
